import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { history } from './helpers';
import { store } from './helpers';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { loadUser } from "redux-oidc";
import { getUserManager } from './util/userManager';
import axios from 'axios';
import './index.css';
import { setUserManagerConfig} from './util/sessionUtil';
import { getToken} from './util/sessionUtil';


//axios.defaults.baseURL = '/api';
  axios.defaults.baseURL = '/shipment';
axios.get("/public/getConfig", {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    //'proxy':'http://localhost:9090'
  }
})
  .then((response) => {
    console.log("response:",response);
    sessionStorage.clear();
    setUserManagerConfig(response.data);
     console.log("response Data:",response.data);
    var userManager = getUserManager();
    console.log("UserManager:",userManager);
    loadUser(store, userManager);
    render();
  })
  .catch((err) => {
    console.log(err);
  });
    // sessionStorage.clear();
    // console.log(returnData);
    // setUserManagerConfig(returnData);
    // var userManager =getUserManager();
    // console.log('userManager:',userManager);
    // loadUser(store,userManager);
const render = () =>{
ReactDOM.render(
<Provider store={store}>
	<div>
	<App history={history} store={store} />
	<ReduxToastr
		timeOut={5000}
		newestOnTop={false}
		preventDuplicates
		position="bottom-right"
		transitionIn="fadeIn"
		transitionOut="fadeOut"
	 />
	</div>
</Provider>,
document.getElementById("root")
);

//registerServiceWorker();
}
